
const SERVER_BASE_URL = "https://api.canedconsulting.ca"

export default {
  async getNextUserID (email) {
    return await fetch(`${SERVER_BASE_URL}/generate`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({email: email})
    })
  }
}



// WEBPACK FOOTER //
// ./src/request.js